// the css is injected automatically

var strip = require("striphtml");
var parsing = require('parsing').consentmainlabel;

function parse(text, next) {

    strip(require('raw!./consentmainlabel.html'), function(outputHtml) {
        var parseRe = /\[consentmainlabel\]/gi;
        var match = parsing.parse(text);

        if( match ) {
            text = text.replace(match[0], outputHtml);
        }

        next(text);
    });
};

function init(formRoot, meta, next) {
    next(formRoot);
}

module.exports = {
    parse: parse,
    init: init,
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/consentmainlabel/consentmainlabel.js